export default __webpack_public_path__ + "static/media/0000..0005.4ca659b5.png";